import { ReactNode } from "react"
import cn from "../../../../utils/classes"

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  id: string
  children: ReactNode | ReactNode[]
}

export const TableRow: React.FC<TableRowProps> = ({
  id,
  children,
  ...props
}) => {
  const className = cn("bg-white hover:bg-gray-50", props.className)

  return (
    <tr {...props} id={id} className={className}>
      {children}
    </tr>
  )
}
